import { Controller } from "stimulus"
import Rails from 'rails-ujs'

export default class extends Controller {
  reset() {
    document.getElementById('composition-preview').innerHTML = ""
    document.getElementById("composition").classList.remove('d-none')
  }
}
